import React from "react"
import "./style.css"
import { Link } from "react-router-dom"

export default function NotFound() {
  return (
    <div className="notfoundContainer">
      <div className="notfound">
        <div className="notfound-404">
          <h1>404</h1>
        </div>
        <h1>We are sorry, Page not found!</h1>
        <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
        <Link to="/">Back To Homepage</Link>
      </div>
    </div>
  )
}
